import type { FilterConfig } from '../interfaces/filterConfig';
import { useFilterConfigs } from './useFiltersConfig';

export const useFilterConfig = (
  value: string | { attributeName?: string; urlKey?: string },
): FilterConfig | undefined => {
  const filterConfigs = useFilterConfigs();
  const attributeName = typeof value === 'string' ? value : value.attributeName;
  const urlKey = typeof value === 'object' ? value.urlKey : undefined;

  return filterConfigs.find(
    (filterConfig) =>
      filterConfig.attributeName === attributeName ||
      (urlKey && filterConfig.urlKey === urlKey),
  );
};
